import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import './Guide.css';

const Guide = () => {
  const [showAccordion, setShowAccordion] = useState(false);

  const toggleAccordion = () => {
    const isOpening = !showAccordion;
    setShowAccordion(isOpening);
    document.body.style.overflow = isOpening ? 'hidden' : '';
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 900) {
      setShowAccordion(false);
      document.body.style.overflow = '';
    }
  };

  return (
    <div className='guides'>
      <button style={{height:'80px',width:'15px'}}
        className="accordion-toggle-btn"
        onClick={toggleAccordion}
        aria-label="Toggle sidebar"
      >
        
      </button>

      <div
        className={`accordion accordion-flush non-outlet ${showAccordion ? 'show-on-mobile' : ''}`}
        id="accordionFlushExample"
      >

        <div className="accordion-item">
          <h2 className="accordion-header">
            <Link to="modular">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                Modular Kitchen Design Guides
              </button>
            </Link>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <a href="#modular1" onClick={handleLinkClick}>Modular vs Civil Kitchen</a><hr />
              <a href="#modular2" onClick={handleLinkClick}>5 Things To Know Before You Start</a><hr />
              <a href="#modular3" onClick={handleLinkClick}>How To Plan Your Kitchen Interiors</a><hr />
              <a href="#modular4" onClick={handleLinkClick}>Maximize Storage Space In Kitchen</a>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <Link to="bedroomguide">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="false"
                aria-controls="flush-collapseTwo"
              >
                Bedroom Design
              </button>
            </Link>
          </h2>
          <div
            id="flush-collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <a href="#bedroom1" onClick={handleLinkClick}>Bedroom Design Checklist</a><hr />
              <a href="#bedroom2" onClick={handleLinkClick}>A Comprehensive Guide To Bedroom Decor</a><hr />
              <a href="#bedroom3" onClick={handleLinkClick}>All About Beds</a><hr />
              <a href="#bedroom4" onClick={handleLinkClick}>Wardrobe Designs To Suit Your Bedroom</a>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <Link to="livingroomguide">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="false"
                aria-controls="flush-collapseThree"
              >
                Living Room Interior Design Guides
              </button>
            </Link>
          </h2>
          <div
            id="flush-collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <a href="#livingroomguide1" onClick={handleLinkClick}>Living Room design Checklist</a><hr />
              <a href="#livingroomguide2" onClick={handleLinkClick}>The Ultimate Living Room Storage And Organization Guide</a><hr />
              <a href="#livingroomguide3" onClick={handleLinkClick}>Living Room Design Style</a><hr />
              <a href="#livingroomguide4" onClick={handleLinkClick}>All About Living Room Decor</a>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFour"
              aria-expanded="false"
              aria-controls="flush-collapseFour"
            >
              <Link to="/guides/accordion-item-4">Accordion Item #4</Link>
            </button>
          </h2>
          <div
            id="flush-collapseFour"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <a href="#accordion4-1" onClick={handleLinkClick}>Placeholder content for this accordion.</a>
            </div>
          </div>
        </div>

      </div>

      <div className="outlet-container">
        <Outlet />
      </div>
    </div>
  );
};

export default Guide;
